<template>
  <div class="header-frame">
    <header>
      <div class="flex-display flex-row-between">
        <div class="logo">
          <!-- 派加 -->
          <img v-if="webType === 0" :src="`${$baseImgUrlTow}20220519/6441431d-0ff6-4dac-8434-811521b833d6.png`" alt="" />
          <!-- 卡百利 -->
          <img v-else-if="webType === 1" :src="`${$baseImgUrlTow}20220107/480aa2a0-2b6a-4b0d-9fc1-eefcb9627b4a.png`" alt="" />
        </div>
        <ul class="nav-frame flex-display flex-center-align">
          <li
            class="nav-item flex-display flex-center-align"
            v-for="(item, index) in navs"
            @click="changeNav(item, item.href)"
            :key="index"
            :class="{ active: item.fatherHref == currentFatherHref }"
            @mouseenter="onShow(item)"
            @mouseleave="onHide(item)"
          >
            <span class="text">{{ item.text }}</span>
            <img
              class="icon"
              :src="`${$baseImgUrl}images/icon-up.png`"
              v-if="item.isIcon && item.isShow"
              alt=""
            />

            <img
              class="icon"
              :src="`${$baseImgUrl}images/icon-down.png`"
              v-if="item.isIcon && !item.isShow"
              alt=""
            />

            <div class="tooltip" :class="{ show: item.isShow ? true : false }">
              <div class="tooltip-list flex-display flex-display-column">
                <span
                  class="list-item"
                  @click="changeNav(item, listItem.href, 'childRoute')"
                  :class="{ active: currentPath === listItem.href }"
                  v-for="(listItem, index) in item.child"
                  :key="index"
                  >{{ listItem.text }}</span
                >
              </div>
            </div>
          </li>
        </ul>
      </div>
    </header>
  </div>
</template>
<script>
var navs = [{
  text: '首页',
  href: '/home',
  fatherHref: 'home',
  isShow: false,
  isIcon: false

}, {
  text: '产品',
  href: '',
  isIcon: true,
  isShow: false,
  fatherHref: 'goods',
  child: [{
    text: '数字名片',
    href: '/businessCard'

  },
  {
    text: '门店商城',
    href: '/shopMall'

  },
  {
    text: '派加门店助手',
    href: '/helper'

  },
  {
    text: '设计中台',
    href: '/design'

  }
  ]

},
{
  text: '关于我们',
  href: '',
  isIcon: true,
  isShow: false,
  fatherHref: 'us',
  child: [{
    text: '公司简介',
    href: ''

  },
  {
    text: '大事记',
    href: ''

  },
  {
    text: '分公司',
    href: ''

  },
  {
    text: '联系我们',
    href: '/contactUs'

  }
  ]

}]
export default {
  name: 'Header',
  data () {
    return {
      currentFatherHref: 'home',
      isShow: true, // 是否显示
      shadowFlag: false,
      num: 0,
      currentSeat: '',
      navs,
      navActiveIndex: -1,
      currentPath: null
    }
  },

  components: {
  },
  created () {
    var path = this.$route.path
    this.currentPath = this.$route.path
    if (path === '/home') {
      this.currentFatherHref = 'home'
    } else if (path === '/businessCard' || path === '/shopMall' || path === '/helper' || path === '/design') {
      this.currentFatherHref = 'goods'
    } else if (path === '/contactUs') {
      this.currentFatherHref = 'us'
    }
    // 如果是派加
    if (this.webType === 0) {
      console.info(this.navs[1].child[2].text, '-----')
      this.navs[1].child[2].text = '派加门店助手'
    } else if (this.webType === 1) {
      console.info(this.navs[1].child[2].text, '-----')
      this.navs[1].child[2].text = '卡百利门店宝'
    }
  },
  methods: {
    changeNav (item, href, childRoute) {
      // eslint-disable-next-line no-mixed-operators
      if (href === '/home' && !childRoute || childRoute) {
        this.currentFatherHref = item.fatherHref
      }

      item.isShow = false
      // eslint-disable-next-line eqeqeq
      if (href && href != this.currentSeat) {
        this.$router.push(href)
        this.currentPath = href
        this.currentSeat = href
      }
    },
    changeShow () {

    },
    onShow (item) {
      item.isShow = true
    },
    onHide (item) {
      item.isShow = false
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/header.vue